import { fields, createSchema, validate as _validate } from '..';

const { requiredText } = fields;

const schema = createSchema({
  confidentInMathsAbility: requiredText,
  canManageEverydayLife: requiredText,
  communicateWellWithOthers: requiredText,
  budgetManageMoney: requiredText,
  everydayTasksWithNumbers: requiredText,
  dealWithConflict: requiredText,
  mathsGoals: requiredText,
  optimisticAboutFuture: requiredText,
  happyWithProgress: requiredText,
  education: requiredText,
  employment: requiredText,
});

const validate = (data) => _validate(schema, data);

export default validate;
